const Insights = () => (
  <div className="flex flex-col items-center justify-center min-h-[60vh] w-full">
    <span className="text-2xl font-semibold text-gray-600 mt-32">
      Coming Soon
    </span>
  </div>
);

export default Insights;
